import { ActionIcon, Tooltip } from "@mantine/core";
import {
  IconEdit,
  IconPresentationAnalytics,
  IconTrash,
} from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import { StyledActionIcon } from "src/styled";

interface IReportsActionButtons {
  reportId: string;
  open: () => void;
  setCurrentRid: any;
}

const ReportsActionButtons = ({
  reportId,
  open,
  setCurrentRid,
}: IReportsActionButtons) => {
  const navigate = useNavigate();

  const handleEdit = () => {
    navigate(`/reports/edit-report/${reportId}`);
  };

  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        justifyContent: "end",
        alignItems: "end",
        height: "77px",
      }}>
      <Tooltip label="Run Report">
        <StyledActionIcon
          onClick={e => {
            e.stopPropagation();
            navigate(`/reports/report/${reportId}`);
          }}>
          <IconPresentationAnalytics />
        </StyledActionIcon>
      </Tooltip>
      <Tooltip label="Edit">
        <StyledActionIcon
          onClick={e => {
            e.stopPropagation();
            handleEdit();
          }}>
          <IconEdit />
        </StyledActionIcon>
      </Tooltip>
      <Tooltip label="Remove">
        <ActionIcon
          data-cy="remove-report-button"
          onClick={e => {
            e.stopPropagation();
            setCurrentRid(reportId);
            open();
          }}>
          <IconTrash color="#ff6b6b" />
        </ActionIcon>
      </Tooltip>
    </div>
  );
};

export default ReportsActionButtons;
